import React from 'react';
import { useNavigate } from 'react-router-dom';
import { generateProfileUrl } from '../../../utils/urlSlug';

export interface UserProfileLinkProps {
  userId?: string;
  name?: string;
  lastname?: string;
  children: React.ReactNode;
  className?: string;
}

const UserProfileLink: React.FC<UserProfileLinkProps> = ({
  userId,
  name,
  lastname,
  children,
  className
}) => {
  const navigate = useNavigate();

  if (!userId) {
    return <>{children}</>;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(generateProfileUrl(name, lastname, userId));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(generateProfileUrl(name, lastname, userId));
    }
  };

  return (
    <span
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      className={className}
      style={{ cursor: 'pointer' }}
    >
      {children}
    </span>
  );
};

export default UserProfileLink;
